import ModalLead from "./ModalLead";
export default ModalLead;